import { useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Collapse } from "reactstrap";
// componentes
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ImportFlight from "./ImportFlight";
import ImportUpdateFlight from "./ImportUptadeFlight";
import ImportDeleteFlight from "./ImportDeleteFlight";

export default function ModalAllImports(props) {
  const { toggle, isOpen, idEvent, data } = props;
  //   collapse
  const [collapseCreate, setCollapseCreate] = useState(false);
  const [collapseUpdate, setCollapseUpdate] = useState(false);
  const [collapseDelete, setCollapseDelete] = useState(false);

  function toggleCollapseCreate() {
    setCollapseCreate(!collapseCreate);
    setCollapseUpdate(false);
    setCollapseDelete(false);
  }

  function toggleCollapseUpdate() {
    setCollapseCreate(false);
    setCollapseUpdate(!collapseUpdate);
    setCollapseDelete(false);
  }

   function toggleCollapseDelete() {
    setCollapseCreate(false);
    setCollapseUpdate(false);
    setCollapseDelete(!collapseDelete);
  }

  return (
    <>
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Importadores de Voo</ModalHeader>
        <ModalBody>
          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Criar Voos"
              setIsOpen={toggleCollapseCreate}
              isOpen={collapseCreate}
            />
          </Row>

          <Collapse isOpen={collapseCreate}>
            <ImportFlight toggleModal={toggle} idEvent={idEvent} data={data} />
          </Collapse>

          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Atualizar Voos"
              setIsOpen={toggleCollapseUpdate}
              isOpen={collapseUpdate}
            />
          </Row>

          <Collapse isOpen={collapseUpdate}>
            <ImportUpdateFlight
              toggleModal={toggle}
              idEvent={idEvent}
              data={data}
            />
          </Collapse>

          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Deletar Voos"
              setIsOpen={toggleCollapseDelete}
              isOpen={collapseDelete}
            />
          </Row>

          <Collapse isOpen={collapseDelete}>
            <ImportDeleteFlight
              toggleModal={toggle}
              idEvent={idEvent}
              data={data}
            />
          </Collapse>
        </ModalBody>
      </Modal>
    </>
  );
}
